<template>
    <section>
        <b-loading :active="isLoading" @update:active="isLoading = $event"></b-loading>
        <titlebar :title-stack="titleStack">
        </titlebar>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)">
                <div class="notification is-info" v-if="salvandoDados">
                    <button class="delete"></button>
                    {{$t('NIVELDEACESSOCADASTRO.SALVANDONIVEL')}}
                </div>

                <div class="tile is-ancestor">
                    <div class="tile is-parent is-vertical is-9">
                        <article class="tile is-child box">
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider rules="required" name="nome" v-slot="{ errors, valid }">
                                        <b-field :label="$t('SISTEMA.NOME')"
                                                    :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                                    :message="errors">
                                            <b-input type="text" v-model="model.nome" maxlength="50"></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div  class="column is-one-third">
         
                                </div>                                
                            </div>

                            <cadastro-items v-if="model.administrador" :label="$t('NIVELDEACESSOCADASTRO.UNIDADESDECADASTRO')" :items="model.unidadesDeAcesso" @update:items="model.unidadesDeAcesso = $event" tabela="unidade" style="width:99%" class="mt-4"/>                            
                  
                        </article>
                    </div>
                    <div class="tile is-parent">

                        <article class="tile is-child">
                            <article class="panel">
                                <div>
                                    <div class="panel-block">
                                        <b-switch v-model="model.administrador">
                                            {{$t('NIVELDEACESSOCADASTRO.ADM')}}
                                        </b-switch>  
                                    </div>
                                                                             
                                </div>
                            </article>  
                            <historico-alteracoes :tabela="'NivelDeAcesso'" :chave="model.id"></historico-alteracoes>     

                            <article class="panel">
                                <div>
                                    <div class="panel-heading has-text-centered">
                                        {{$t('NIVELDEACESSOCADASTRO.COPIARDE')}}
                                    </div>
                                    <div class="panel-block" style="display: block;">
                                        <b-button native-type="button" expanded icon-left="content-copy" @click="showModal" :title="$t('NIVELDEACESSOCADASTRO.COPIARDE')"></b-button>
                                    </div>
                                </div>
                            </article>
                        </article>                        
                                          

                        
                                                                      
                                              
                    </div>
                </div>
                <article class="tile is-child box" v-if="model.regrasExistentes != null && model.regrasExistentes.length > 0">
                    <b>{{$t('NIVELDEACESSOCADASTRO.REGRAS')}}</b>
                    <span><b-switch style="float: right;" size="is-small" v-model="marcarTodos" @input="marcaTodos()">Marcar Todos?</b-switch></span>
                    <template v-for="(grupo, i) in grupos">
                        <collapse-groups :index="i" :titulo="grupo" v-bind:key="grupo">
                            <tbody>
                                <tr v-for="item in regrasDoGrupo(grupo)" v-bind:key="item.id">
                                    <td>
                                        <input @change="alterouNivel(item.nome)" type="checkbox" v-if="model.regras.filter(x => x.nome == item.nome).length > 0" checked>
                                        <input @change="alterouNivel(item.nome)" type="checkbox" v-else>
                                    </td>                                    
                                    <td>
                                        <div>{{item.descricao}}</div>
                                        <small class="has-text-grey">{{item.nome}}</small>
                                    </td>
                                </tr>
                            </tbody>
                        </collapse-groups>
                        <br v-bind:key="`${grupo}-espaco`">
                    </template>
                </article>
                <br>
                <nav class="level">
                    <div class="level-item">
                        <p class="buttons">
                            <b-button type="is-success"
                                      :loading="salvandoDados"
                                      native-type="submit"
                                      icon-left="check-circle">
                                {{$t('SISTEMA.SALVAR')}}
                            </b-button>
                            <b-button type="is-danger"
                                      native-type="button"
                                      icon-left="close-circle"
                                      @click="$router.back();">
                                {{$t('SISTEMA.CANCELAR')}}
                            </b-button>
                        </p>
                    </div>
                </nav>
            </form>
        </ValidationObserver>
    </section>
</template>

<script>
    import http from '@/http'
    import { mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'
    import historicoAlteracoes from '@/components/historicoAlteracoes.vue'
    import modalCopiarDe from '@/components/modalCopiarDe.vue'
    import collapseGroups from '@/components/manutencao/collapseGroups.vue'
    import cadastroItems from '@/components/manutencao/cadastroItems.vue'

    export default {
        data() {
            return {            
                model: {
                    id: null,
                    nome: null,                    
                    administrador: null,                    
                    regras: null,
                    regrasExistentes: null, 
                    unidadesDeAcesso: [],
                    bloquearAcessoAtrasos:null,
                    quantidadeAtrasos:0,                   
                },
                marcarTodos: false,
                salvandoDados: false,                
                isLoading:false,
            }
        },
        components: {
            titlebar,
            historicoAlteracoes,
            collapseGroups,
            cadastroItems
        },
        computed: {
            grupos() {
                return [...new Set((this.model.regrasExistentes || []).map(regra => regra.grupo || 'Sem grupo'))]
                    .sort((a, b) => a.localeCompare(b, 'pt-BR'))
            },
            ...mapState([
                'unidadeId'                            
            ]),            
            titleStack() {
                return [
                    this.$t('SISTEMA.MANUTENCAO'),
                    this.$t('NIVELDEACESSOCADASTRO.NIVEL'),
                    this.$route.params.id ?? this.$t('SISTEMA.NOVO')
                ]
            },
            ...mapState([            
                'usuario',                                
            ]),              
            
        },
        methods:{
            regrasDoGrupo(grupo) {
                return (this.model.regrasExistentes || [])
                    .filter(regra => (regra.grupo || 'Sem grupo') === grupo)
                    .sort((a, b) => (a.descricao || a.nome).localeCompare(b.descricao || b.nome, 'pt-BR'))
            },
            onSubmit() {
                this.salvandoDados = true;    


                if(!this.model.administrador)
                    this.model.unidadesDeAcesso = [];                
                
                this.model.UnidadeDeCadastro = { id : this.unidadeId};

                if(!this.model.bloquearAcessoAtrasos)
                    this.model.quantidadeAtrasos = 0;

                http.post(`/api/manutencao/nivel`, this.model )
                    .then(() => {
                        this.salvandoDados = false;
                        this.$router.back()
                    })
                    .catch((error) => {
                        this.salvandoDados = false;
                        throw error
                    });       
            },

            alterouNivel(regra){
                if(this.model.regras == null){
                    this.model.regras = [];
                }

                if(this.model.regras.filter(x => x.nome == regra).length == 0){
                    this.model.regras.push({
                        id: this.model.regrasExistentes.filter(x => x.nome == regra)[0].id,
                        nome: this.model.regrasExistentes.filter(x => x.nome == regra)[0].nome
                    });
                }
                else 
                {
                    let index = -1;
                    for (const i in this.model.regras) {
                        if(this.model.regras[i].nome == regra) {
                            index = i;
                            break;
                        }
                    }

                    if(index > -1)
                    {
                        this.model.regras.splice(index, 1);
                    }
                }
            },
            marcaTodos(){
                this.model.regras = []

                if(this.marcarTodos){
                    this.model.regras = this.model.regrasExistentes.map(regra => {
                        return {
                            id: regra.id,
                            nome: regra.nome
                        };
                    });
                }
            },
            showModal(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalCopiarDe,
                    events: {
                        copiarNivelDeAcesso: this.copiarNivelDeAcesso
                    },
                    hasModalCard: true,
                    trapFocus: true
                })
            },
            copiarNivelDeAcesso(nivelDeAcesso){
                this.model.regras = nivelDeAcesso.map(regra => {
                    return {
                        id: regra.id,
                        nome: regra.nome
                    };
                });
            },
        },
        created() {

            this.isLoading= true;

            let url = '/api/manutencao/niveldeacesso?id=' + this.$route.params.id
            if(!this.$route.params.id){
                url = '/api/manutencao/niveldeacesso'
            }
            http.get(url)
                .then(res => {
                    this.model = res.data;

                    if(this.model.regras == null){
                        this.model.regras = [];
                    }                  
                    
                }).finally(() => {
                        this.isLoading= false;
                });
        }
    }
</script>
